import { render, staticRenderFns } from "./editorbox.vue?vue&type=template&id=5dfb2b7e"
import script from "./editorbox.vue?vue&type=script&lang=js"
export * from "./editorbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports